import styled, {css} from "styled-components"

export const RecipientContainer = styled.li`
  display: inline-flex;
  align-items: center;
  border-radius: 100px;
  list-style: none;
  line-height: 0;
  ${({theme}) => `
    border: 1px solid ${theme.colors.greys.mediumLight};
    gap: ${theme.spacing.one};
    padding: ${theme.spacing.half} ${theme.spacing.one};
    background: ${theme.colors.greys.lightest};
  `}
`
export const ExtraRecipient = styled.li`
  color: ${({theme}) => theme.colors.primary2};
`
export const ExpandList = styled.div`
  ${({theme}) => css`
    display: flex;
    list-style: none;
    margin-top: ${theme.spacing.two};
    align-items: center;
    color: ${theme.colors.primary2};
    img {
      margin-left: ${theme.spacing.one};
      width: 16px;
      height: 16px;
    }
  `}
`
export const ArrowUp = styled.img`
  transform: rotate(180deg);
`
export const RecipientsListContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  ${({theme}) => `
    gap: ${theme.spacing.one};
  `}
`
